import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import DashboardInsights from './DashboardInsights';
import MainLayout from '../../layouts/MainLayout';
import subscriptionManager from '../../utils/subscriptionManager';

// 方案積分上限對照
const PLAN_CREDITS = {
  basic: { max: 500, name: 'AI 基礎版' },
  professional: { max: 1000, name: 'AI 專業版' },
  brand: { max: 10000, name: 'AI 品牌版' }
};

function DashboardInsightsPage() {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [currentCredits, setCurrentCredits] = useState(692);
  const [planType, setPlanType] = useState('basic');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSubscription = async () => {
      try {
        const type = await subscriptionManager.getUserPlanType();
        setPlanType(type);
        // TODO: 從 API 獲取實際積分
        // const credits = await fetchCredits();
        // setCurrentCredits(credits);
      } catch (error) {
        console.error('Error loading subscription:', error);
      } finally {
        setLoading(false);
      }
    };
    loadSubscription();
  }, []);

  const planInfo = PLAN_CREDITS[planType] || PLAN_CREDITS.basic;
  const displayCredits = Math.min(currentCredits, planInfo.max); // 不能超過上限
  const progressPercent = (displayCredits / planInfo.max) * 100;

  return (
    <MainLayout activePage="dashboard-insights">
      <div className="flex-1 flex flex-col">
          {/* Header */}
          <div
            className="px-10 py-5 flex items-center justify-between"
            style={{ borderBottom: `1px solid ${theme.borderColor}` }}
          >
            <div>
              <h1
                className="m-0 mb-2 text-[1.75rem] font-bold"
                style={{ color: theme.textPrimary }}
              >
                {t('dashboardInsightsPage.title')}
              </h1>
              <p
                className="m-0 text-sm"
                style={{ color: theme.textSecondary }}
              >
                {t('dashboardInsightsPage.subtitle')}
              </p>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="flex-1 p-10 overflow-y-auto">
            <DashboardInsights />

            {/* Current Credits Card */}
          </div>
        </div>
    </MainLayout>
  );
}

export default DashboardInsightsPage;
